/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：286
 */

"use strict"

var r
export { r as a };
(function (e) {
  e.ARROW = "ARROW"
  e.CIRCLE = "CIRCLE"
  e.NONE = "NONE"
})(r || (r = {}))
export default r
